module.exports = __webpack_public_path__ + "static/media/nikita.faf04359.jpg";